import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DepotSelectComponent } from './depot-select.component';
import { TranslocoModule } from '@jsverse/transloco';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormErrorModule, SelectModule } from '@eg/ui';

@NgModule({
  declarations: [DepotSelectComponent],
  exports: [DepotSelectComponent],
  imports: [CommonModule, SelectModule, TranslocoModule, FlexLayoutModule, FormErrorModule],
})
export class DepotModule {}
